/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form, Button, Row, Col, Space,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import FormItem from '../formItem';

const Search = ({
  onSubmit,
  fields,
  extra,
  initialValues,
  getForm,
  onExportData,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (getForm) {
      getForm(form);
    }
  }, [getForm]);

  return (
    <Form
      form={form}
      onFinish={onSubmit}
      initialValues={initialValues}
      onValuesChange={onExportData}
    >
      <Row gutter={24}>
        {
            fields.map((f) => (f.fields?.length ? (
              <Col>
                <Form.Item name={f.name} label={f.label} style={{ marginBottom: 0 }}>
                  <Row size={20} align="middle">
                    {
                    f.fields.map((cf, index) => (
                      <>
                        {index > 0 && <span style={{ margin: '0 10px 24px' }}>{f.separator}</span>}
                        <FormItem
                          key={cf.name}
                          mult={cf.mult}
                          form={form}
                          name={cf.name}
                          label={cf.label}
                          type={cf.type}
                          inputProps={{
                            ...cf.inputProps,
                            onChange: (val) => {
                              if (cf?.inputProps?.onChange) {
                                cf.inputProps.onChange(val, cf.name);
                              }
                            },
                          }}
                          labelAlign="right"
                        />
                      </>
                    ))
                  }
                  </Row>
                </Form.Item>
              </Col>
            ) : (
              <div style={{ minWidth: 250, marginLeft: 30 }}>
                <FormItem
                  mult={f.mult}
                  form={form}
                  name={f.name}
                  label={f.label}
                  type={f.type}
                  inputProps={f.inputProps}
                  labelAlign="right"
                />
              </div>
            )))
          }
        <Col />
        <Form.Item>
          <Space size={10}>
            <Button icon={<SearchOutlined />} type="primary" htmlType="submit">搜索</Button>
            <Button
              onClick={() => {
                form.resetFields();
                form.submit();
                onExportData({}, {});
              }}
            >
              重置
            </Button>
          </Space>
        </Form.Item>
        {extra}
      </Row>
    </Form>
  );
};

Search.propTypes = {
  onSubmit: PropTypes.func,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      type: PropTypes.string,
      inputProps: PropTypes.shape({}),
    }),
  ),
  extra: PropTypes.oneOf([PropTypes.node, PropTypes.string]),
  initialValues: PropTypes.shape({}),
  getForm: PropTypes.func,
  onExportData: PropTypes.func,
};

Search.defaultProps = {
  onSubmit: () => {},
  fields: [],
  extra: null,
  initialValues: {},
  getForm: () => {},
  onExportData: () => {},
};

export default Search;
